import { render, staticRenderFns } from "./E-sports.vue?vue&type=template&id=5ac07541"
import script from "./E-sports.vue?vue&type=script&lang=js"
export * from "./E-sports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports